/* eslint-disable react-hooks/rules-of-hooks */
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton, Snackbar } from '@mui/material';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import { ColumnDef } from '@tanstack/table-core';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ShareIcon from '@mui/icons-material/Share';
// eslint-disable-next-line import/no-cycle
import {
  getOutputColumnWithoutToggle,
  getTableColumnData
} from 'src/components/collapsible-table/table-column-prep';
import MODULE_TO_PAGE_MAP from '../../../../home/types/simulation-module-to-page-map';
import CreateOverwriteSKU from '../../../../innovation/components/overwrite-sku-component/create-overwrite-sku';
import { editInputFieldValues } from '../../../../innovation/store/innovation-slice';
import {
  deleteSku,
  duplicateCurrSku,
  fetchOverwriteMetadata
} from '../../../../innovation/store/innovation-slice-async-thunks';
import {
  Header,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import { toggleShareScenarioDialogVisibility } from '../../../../scenario-manager/scenario-manager-slice';

export default function getColumnForIMOAction(
  componentType: TableComponent,
  columnData: Header,
  rowData: any
) {
  const appDispatch = useAppDispatch();

  // getting user, scenario and source details from useModuleMetadata hooks
  const { moduleId, sourceId, scenarioId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.INNOVATION
  });

  // getting state of innovation
  const { isSimulated } = useAppSelector((state) => state.innovation);
  // local state for snackbar
  const [isSnackbarOpen, setSnackbar] = useState(false);
  // Handler for snackbar
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(false);
  };

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
    <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
  ));
  // const [open, setOpen] = React.useState(false);
  const [isOverwriteDialogOpen, setIsOverwriteDialogOpen] = useState(false);
  const [snackbarContent, setSnackbarContent] = useState<{
    snackbarText: string;
    snackbarType: AlertColor;
  }>({
    snackbarText: '',
    snackbarType: 'success'
  });

  // handler for cogs dialog close
  const handleOverwriteDialogClose = () => {
    setIsOverwriteDialogOpen(false);
    // appDispatch(resetCogsFilters());
  };
  const onOverwriteButtonClick = (rowObj) => {
    // setting dilogue open state to true
    setIsOverwriteDialogOpen(true);

    // calling get metadata api
    appDispatch(
      fetchOverwriteMetadata({
        sourceID: sourceId,
        moduleID: moduleId,
        scenarioID: Number(scenarioId),
        skuName: rowObj.original.sku
      })
    ).then((res) => {
      if (res.meta.requestStatus === 'rejected') {
        setSnackbarContent({
          // eslint-disable-next-line dot-notation
          snackbarText: res['error'].message,
          snackbarType: 'error'
        });
        setSnackbar(true);
      }
    });
  };

  return (
    <>
      <Grid container justifyContent='center' style={{ color: '#0000A0' }}>
        <Grid item>
          <IconButton
            color='primary'
            disabled={
              !(
                rowData.original.innovation_sales_units ||
                rowData.original.innovation_is_mo_applied
              )
            }
            aria-label='overwrite'
            onClick={() => onOverwriteButtonClick(rowData)}
          >
            <DriveFileRenameOutlineIcon style={{ fontSize: '16px' }} />
          </IconButton>
          {isOverwriteDialogOpen === true && (
            <CreateOverwriteSKU
              isOverwriteDialogOpen={isOverwriteDialogOpen}
              closeOverwriteDialog={handleOverwriteDialogClose}
            />
          )}
        </Grid>
      </Grid>
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarContent.snackbarType}
          sx={{ width: '100%' }}
        >
          {snackbarContent.snackbarText}
        </Alert>
      </Snackbar>
    </>
  );
}
